// extracted by mini-css-extract-plugin
export var trans_bg = "styles-module--trans_bg--2hJXU";